import { http } from "../client";
import { mapUserResponse } from "./mappers";
export var getViewer = function () {
    return http.api
        .get("/user", { withCredentials: true })
        .then(function (_a) {
        var data = _a.data;
        return mapUserResponse(data.data);
    });
};
